import React, { useCallback, useEffect, useState } from "react";
import {
  Badge,
  Box,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { fetchComplianceTasks } from "../services/complianceService";

const ComplianceTasksPanel = () => {
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchComplianceTasks({ status: "pending" });
      setTasks(data.tasks || []);
    } catch (err) {
      console.warn("Compliance tasks:", err);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box bg="white" borderRadius="md" shadow="sm" p={4}>
      <Text fontWeight="semibold" mb={3}>
        Care coordinator outreach tasks
      </Text>
      {loading ? (
        <Spinner size="sm" />
      ) : tasks.length === 0 ? (
        <Text fontSize="sm" color="gray.500">
          No pending outreach tasks. Create one from an alert via &quot;Create
          outreach task&quot;.
        </Text>
      ) : (
        <Box overflowX="auto">
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Patient</Th>
                <Th>Status</Th>
                <Th>Suggested script</Th>
              </Tr>
            </Thead>
            <Tbody>
              {tasks.map((t) => (
                <Tr key={t.id}>
                  <Td>{t.patient_name || t.patient_id}</Td>
                  <Td>
                    <Badge colorScheme="yellow">{t.status}</Badge>
                  </Td>
                  <Td maxW="400px" whiteSpace="normal" fontSize="xs">
                    {t.suggested_script}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default ComplianceTasksPanel;
